import { ActivatedRouteSnapshot } from '@angular/router';

/**
 * Builds the route template (e.g. /transactions/:id) from the route config
 * paths of the activated snapshot tree. Never uses the raw URL, so IDs and
 * query strings cannot leak into telemetry.
 */
export function routeTemplateFromSnapshot(root: ActivatedRouteSnapshot): string {
  const segments: string[] = [];
  let current: ActivatedRouteSnapshot | null = root;
  while (current) {
    const path = current.routeConfig?.path;
    if (path) {
      segments.push(path);
    }
    current = current.firstChild;
  }
  return '/' + segments.join('/');
}
